import { Component, OnInit } from '@angular/core';
import { CollectionService } from '../Services/collection';
import { LanguageService } from '../Services/lang';
import { Collection } from '../Models/collection';

@Component({
  selector: 'list-collections',
  templateUrl: '../Templates/collection.list.html',
})

export class CollectionListComponent implements OnInit {

  collections: Collection[];

  constructor(private collectionService: CollectionService,
              private lang: LanguageService,
             ) { }

  getCollections(): void {
    this.collectionService.list()
    .subscribe(data => this.collections = data['results'])
  }

  ngOnInit() {
    //this.getCollections();

    // Whenever a language change occurs, get new content.
    this.lang.getLanguage().subscribe(
      data => { this.getCollections(); }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/Components/collection.list.ts